import { useQuery } from "@tanstack/react-query";
import type { City } from "@/lib/types";
import { API_BASE_URL } from "@/lib/api/config";

const fetchCities = async (): Promise<City[]> => {
  const response = await fetch(`${API_BASE_URL}/api/locations/cities`);
  if (!response.ok) {
    throw new Error("Failed to fetch cities");
  }
  const data = await response.json();
  return data.data.cities; // Adjust based on your actual API response structure
};

export const useCities = () => {
  return useQuery<City[], Error>({
    queryKey: ["cities"],
    queryFn: fetchCities,
    staleTime: Infinity, // Lookup data is generally static
    gcTime: Infinity,
  });
};
